import useSuspenseQuery from 'commons/useSuspenseQuery';
import { PRODUCT_PROTECTION_PLANS_META } from 'data-hooks/queries';
import usePDPApolloQueryVariables from '../usePDPApolloQueryVariables';

const useProductProtectionPlans = (id, slug, queryOptions = {}) => {
  const { variables, skip } = usePDPApolloQueryVariables(id, slug);

  const { loading, error, data, refetch } = useSuspenseQuery(
    PRODUCT_PROTECTION_PLANS_META,
    {
      variables,
      skip,
      context: { noBatch: true },
      ssr: queryOptions?.ssr ?? false,
      fetchPolicy: 'cache-and-network',
    }
  );

  return {
    loading: loading || !data,
    error,
    data: data?.productProtectionPlans,
    refetch,
  };
};

export default useProductProtectionPlans;
